import React, { lazy } from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function BundleVisual() {
  const checkoutUrl = 'https://ewordmedia.com/cart/48415277515004:1?checkout';
  return <section className="w-full bg-gradient-to-b from-emerald-50 to-white py-16 md:py-24" data-id="element-135">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <div className="text-center mb-8" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-138">
            The Complete Natural Healing Bundle
          </h2>
          <p className="text-xl text-stone-700 mb-2" data-id="element-139">
            <span className="font-semibold" data-id="element-140">Value: </span>
            <span className="line-through text-stone-500" data-id="element-141">$51</span>
          </p>
          <p className="text-2xl font-bold text-emerald-700" data-id="element-142">
            Yours Today for Only $17
          </p>
        </div>
        <div className="max-w-3xl mx-auto mb-8" data-id="element-143">
          <div className="overflow-hidden rounded-xl shadow-2xl" data-id="element-144">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dg3Uy9C2FYqtx7QuVCpfpS/Natural_Health_Book_Collection-3-Bonus.png" alt="Complete Natural Healing Bundle - 3 Books" className="w-full h-auto object-cover" loading="lazy" data-id="element-145" />
          </div>
        </div>
        <div className="text-center" data-id="element-146">
          <a href={checkoutUrl} data-cta="bundle" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'AddToCart');
          }
        }} className="inline-block bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 focus:from-orange-600 focus:to-orange-700 focus:outline-none focus:ring-4 focus:ring-orange-300 text-white px-10 py-5 rounded-2xl text-lg font-bold transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-[1.02] focus:shadow-xl focus:scale-[1.02] transform" data-id="element-147">
            <span className="flex items-center justify-center gap-2" data-id="element-148">
              <span data-id="element-149">Only $17 Today</span>
              <ChevronRightIcon className="w-5 h-5" data-id="element-150" />
            </span>
          </a>
        </div>
      </div>
    </section>;
}